import { SHWE_VAULT_HISTORY, SHWE_VAULT_STATUS } from './contants';

const initState = {
	shweVaultStatus: [],
	shweVaultHistory: [],
	// Master = hạng cao nhất, suy ra từ rank của login-streak. Để ở store cho
	// mọi nơi (Home, DailyReward...) dùng chung thay vì tự tính lại.
	isMaster: false,
	// loginStreakClaim: [],
	// loginStreakRevive: [],
}

const reducerShweVaultStatus = (state = initState, actions) => {
	switch (actions.type) {
		case SHWE_VAULT_STATUS:
			return {
				...state,
				shweVaultStatus: actions.payload.data,
				isMaster: actions.payload.data?.rank?.toUpperCase() === 'MASTER',
			}
		case SHWE_VAULT_HISTORY:
			return {
				...state,
				shweVaultHistory: actions.payload.data,
			}
		default:
			return state
	}
}
export default reducerShweVaultStatus
